import React from 'react';

// Import CSS files
import '../assets/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/fontawesome-stars-o.min.css';
import '../assets/css/responsive-style.css';
import '../assets/css/colors/theme-color-1.css'; 
import '../assets/css/custom.css';
import '../assets/css/home.css'; 

import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap'; // Import Bootstrap JS
import $ from 'jquery'; // Import jQuery

const App = () => {
    return (
        <div>
           
            <div className="wrapper">
                <div className="posts--filter-bar style--5 hidden-xs">
                    <div className="container">
                        <ul className="nav">
                            <li>
                                <a href="#">
                                    <i className="fa fa-star-o"></i>
                                    <span>Featured News</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-heart-o"></i>
                                    <span>Most Popular</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-fire"></i>
                                    <span>Hot News</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-flash"></i>
                                    <span>Trending News</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-eye"></i>
                                    <span>Most Watched</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="news--ticker">
                    <div className="container">
                        <div className="title">
                            <h2>News Updates</h2>
                            <span>(Update 12 minutes ago)</span>
                        </div>

                        <div className="news-updates--list" data-marquee="true">
                            <ul className="nav">
                                <li>
                                    <h3 className="h3"><a href="#">Contrary to popular belief Lorem Ipsum is not simply random text.</a></h3>
                                </li>
                                <li>
                                    <h3 className="h3"><a href="#">Education to popular belief Lorem Ipsum is not simply</a></h3>
                                </li>
                                <li>
                                    <h3 className="h3"><a href="#">Lorem ipsum dolor sit amet consectetur adipisicing elit.</a></h3>
                                </li>
                                <li>
                                    <h3 className="h3"><a href="#">Corporis repellendus perspiciatis reprehenderit.</a></h3>
                                </li>
                                <li>
                                    <h3 className="h3"><a href="#">Deleniti consequatur laudantium sit aspernatur?</a></h3>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="main-content--section pbottom--30">
                    <div className="container">
                        <div className="main--content">
                            <div className="post--items post--items-1 pd--30-0" data-ajax-content="outer">
                                <ul className="nav row gutter--15" data-ajax-content="inner">
                                    <li className="col-md-12">
                                        <div className="post--item post--layout-1 post--title-large">
                                            <div className="post--img">
                                                <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/photo-gallery-01.jpg" alt="" /></a>
                                                <a href="#" className="cat">Serfer</a>
                                                <a href="#" className="icon"><i className="fa fa-eye"></i></a>

                                                <div className="post--info">
                                                    <ul className="nav meta">
                                                        <li><a href="#">Astaroth</a></li>
                                                        <li><a href="#">Today 05:52 pm</a></li>
                                                    </ul>

                                                    <div className="title text-xxs-ellipsis">
                                                        <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum</a></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="col-md-4 col-xs-6 col-xxs-12">
                                        <div className="post--item post--layout-1">
                                            <div className="post--img">
                                                <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/photo-gallery-02.jpg" alt="" /></a>

                                                <div className="post--info">
                                                    <ul className="nav meta">
                                                        <li><a href="#">Astaroth</a></li>
                                                        <li><a href="#">Today 03:52 pm</a></li>
                                                    </ul>

                                                    <div className="title">
                                                        <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="col-md-4 col-xs-6 col-xxs-12">
                                        <div className="post--item post--layout-1">
                                            <div className="post--img">
                                                <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/photo-gallery-03.jpg" alt="" /></a>

                                                <div className="post--info">
                                                    <ul className="nav meta">
                                                        <li><a href="#">Astaroth</a></li>
                                                        <li><a href="#">Today 03:52 pm</a></li>
                                                    </ul>

                                                    <div className="title">
                                                        <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="col-md-4 hidden-sm hidden-xs">
                                        <div className="post--item post--layout-1">
                                            <div className="post--img">
                                                <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/photo-gallery-04.jpg" alt="" /></a>

                                                <div className="post--info">
                                                    <ul className="nav meta">
                                                        <li><a href="#">Astaroth</a></li>
                                                        <li><a href="#">Today 03:52 pm</a></li>
                                                    </ul>

                                                    <div className="title">
                                                        <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div className="preloader bg--color-0--b" data-preloader="1">
                                    <div className="preloader--inner"></div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="main--content col-md-8 col-sm-7" data-sticky-content="true">
                                    <div className="sticky-content-inner">
                                        <div className="row">
                                            <div className="col-md-6 ptop--30 pbottom--30">
                                                <div className="post--items-title" data-ajax="tab">
                                                    <h2 className="h4">Worlds News</h2>

                                                    <div className="nav">
                                                        <a href="#" className="prev btn-link" data-ajax-action="load_prev_world_news_posts">
                                                            <i className="fa fa-long-arrow-left"></i>
                                                        </a>

                                                        <span className="divider">/</span>

                                                        <a href="#" className="next btn-link" data-ajax-action="load_next_world_news_posts">
                                                            <i className="fa fa-long-arrow-right"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="post--items post--items-2" data-ajax-content="outer">
                                                    <ul className="nav row gutter--15" data-ajax-content="inner">
                                                        <li className="col-xs-12">
                                                            <div className="post--item post--layout-1">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/world-news-01.jpg" alt="" /></a>
                                                                    <a href="#" className="cat">War</a>
                                                                    <a href="#" className="icon"><i className="fa fa-flash"></i></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Astaroth</a></li>
                                                                            <li><a href="#">Yeasterday 03:52 pm</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Siriya attaced by a long established fact that a reader will be distracted by</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-12">
                                                            <hr className="divider" />
                                                        </li>
                                                        <li className="col-xs-6">
                                                            <div className="post--item post--layout-2">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/world-news-02.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Hantu Raya</a></li>
                                                                            <li><a href="#">17 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will done</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-6">
                                                            <div className="post--item post--layout-2">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/world-news-03.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Astaroth</a></li>
                                                                            <li><a href="#">17 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will done</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-12">
                                                            <hr className="divider" />
                                                        </li>
                                                        <li className="col-xs-6">
                                                            
                                                        </li>
                                                       
                                                    </ul>

                                                    <div className="preloader bg--color-0--b" data-preloader="1">
                                                        <div className="preloader--inner"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 ptop--30 pbottom--30">
                                                <div className="post--items-title" data-ajax="tab">
                                                    <h2 className="h4">Technology</h2>

                                                    <div className="nav">
                                                        <a href="#" className="prev btn-link" data-ajax-action="load_prev_technology_posts">
                                                            <i className="fa fa-long-arrow-left"></i>
                                                        </a>

                                                        <span className="divider">/</span>

                                                        <a href="#" className="next btn-link" data-ajax-action="load_next_technology_posts">
                                                            <i className="fa fa-long-arrow-right"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="post--items post--items-3" data-ajax-content="outer">
                                                    <ul className="nav" data-ajax-content="inner">
                                                        <li>
                                                            <div className="post--item post--layout-1">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/technology-01.jpg" alt="" /></a>
                                                                    <a href="#" className="cat">Computer</a>
                                                                    <a href="#" className="icon"><i className="fa fa-heart-o"></i></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bathin</a></li>
                                                                            <li><a href="#">Yeasterday 03:52 pm</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/technology-02.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/technology-03.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/technology-04.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/technology-05.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <div className="preloader bg--color-0--b" data-preloader="1">
                                                        <div className="preloader--inner"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 ptop--30 pbottom--30">
                                                <div className="ad--space">
                                                    <a href="#">
                                                        <img src="/img/ads-img/ad-728x90-01.jpg" alt="" className="center-block" />
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-12 ptop--30 pbottom--30">
                                                <div className="post--items-title" data-ajax="tab">
                                                    <h2 className="h4">Finance</h2>

                                                    <div className="nav">
                                                        <a href="#" className="prev btn-link" data-ajax-action="load_prev_finance_posts">
                                                            <i className="fa fa-long-arrow-left"></i>
                                                        </a>

                                                        <span className="divider">/</span>

                                                        <a href="#" className="next btn-link" data-ajax-action="load_next_finance_posts">
                                                            <i className="fa fa-long-arrow-right"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="post--items post--items-2" data-ajax-content="outer">
                                                    <ul className="nav row" data-ajax-content="inner">
                                                        <li className="col-md-6">
                                                            <div className="post--item post--layout-2">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/finance-01.jpg" alt="" /></a>
                                                                    <a href="#" className="cat">Business</a>
                                                                    <a href="#" className="icon"><i className="fa fa-star-o"></i></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Vassago</a></li>
                                                                            <li><a href="#">Today 03:30 am</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li className="col-md-6">
                                                            <ul className="nav row">
                                                                <li className="col-xs-12 hidden-md hidden-lg">
                                                                    <hr className="divider" />
                                                                </li>

                                                                <li className="col-xs-6">
                                                                    <div className="post--item post--layout-2">
                                                                        <div className="post--img">
                                                                            <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/finance-02.jpg" alt="" /></a>

                                                                            <div className="post--info">
                                                                                <ul className="nav meta">
                                                                                    <li><a href="#">Zepar</a></li>
                                                                                    <li><a href="#">Today 03:52 pm</a></li>
                                                                                </ul>

                                                                                <div className="title">
                                                                                    <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be</a></h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>

                                                                
                                                                <li className="col-xs-12">
                                                                    <hr className="divider" />
                                                                </li>

                                                                

                                                                <li className="col-xs-6">
                                                                    <div className="post--item post--layout-2">
                                                                        <div className="post--img">
                                                                            <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/finance-05.jpg" alt="" /></a>

                                                                            <div className="post--info">
                                                                                <ul className="nav meta">
                                                                                    <li><a href="#">Zepar</a></li>
                                                                                    <li><a href="#">Today 12:35 am</a></li>
                                                                                </ul>

                                                                                <div className="title">
                                                                                    <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be</a></h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>

                                                    <div className="preloader bg--color-0--b" data-preloader="1">
                                                        <div className="preloader--inner"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 ptop--30 pbottom--30">
                                                <div className="post--items-title" data-ajax="tab">
                                                    <h2 className="h4">Politics</h2>

                                                    <div className="nav">
                                                        <a href="#" className="prev btn-link" data-ajax-action="load_prev_politics_posts">
                                                            <i className="fa fa-long-arrow-left"></i>
                                                        </a>

                                                        <span className="divider">/</span>

                                                        <a href="#" className="next btn-link" data-ajax-action="load_next_politics_posts">
                                                            <i className="fa fa-long-arrow-right"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="post--items post--items-2" data-ajax-content="outer">
                                                    <ul className="nav row gutter--15" data-ajax-content="inner">
                                                        <li className="col-xs-12">
                                                            <div className="post--item post--layout-1">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/politics-01.jpg" alt="" /></a>
                                                                    <a href="#" className="cat">Election</a>
                                                                    <a href="#" className="icon"><i className="fa fa-fire"></i></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Astaroth</a></li>
                                                                            <li><a href="#">Yeasterday 03:52 pm</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-12">
                                                            <hr className="divider" />
                                                        </li>
                                                        <li className="col-xs-6">
                                                            <div className="post--item post--layout-2">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/politics-02.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Hantu Raya</a></li>
                                                                            <li><a href="#">17 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will done</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-6">
                                                            <div className="post--item post--layout-2">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/politics-03.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Astaroth</a></li>
                                                                            <li><a href="#">17 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will done</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="col-xs-12">
                                                            <hr className="divider" />
                                                        </li>  
                                                    </ul>

                                                    <div className="preloader bg--color-0--b" data-preloader="1">
                                                        <div className="preloader--inner"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 ptop--30 pbottom--30">
                                                <div className="post--items-title" data-ajax="tab">
                                                    <h2 className="h4">Sports</h2>

                                                    <div className="nav">
                                                        <a href="#" className="prev btn-link" data-ajax-action="load_prev_sports_posts">
                                                            <i className="fa fa-long-arrow-left"></i>
                                                        </a>

                                                        <span className="divider">/</span>

                                                        <a href="#" className="next btn-link" data-ajax-action="load_next_sports_posts">
                                                            <i className="fa fa-long-arrow-right"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="post--items post--items-3" data-ajax-content="outer">
                                                    <ul className="nav" data-ajax-content="inner">
                                                        <li>
                                                            <div className="post--item post--layout-1">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/sports-01.jpg" alt="" /></a>
                                                                    <a href="#" className="cat">Basketball</a>
                                                                    <a href="#" className="icon"><i className="fa fa-eye"></i></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bathin</a></li>
                                                                            <li><a href="#">Yeasterday 03:52 pm</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/sports-02.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/sports-03.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/sports-04.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="/img/home-img/sports-05.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Bune</a></li>
                                                                            <li><a href="#">16 April 2017</a> 
                                                                            </li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30" data-sticky-content="true">
                                    <div className="sticky-content-inner">
                                        {/* Widget Start */}
                                        <div className="widget">
                                            {/* Ad Widget Start */}
                                            <div className="ad--widget">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <a href="#">
                                                            <img src="img/ads-img/ad-300x250-1.jpg" alt="" />
                                                        </a>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <a href="#">
                                                            <img src="img/ads-img/ad-150x150-1.jpg" alt="" />
                                                        </a>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <a href="#">
                                                            <img src="img/ads-img/ad-150x150-2.jpg" alt="" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Ad Widget End */}
                                        </div>
                                        {/* Widget End */}

                                        {/* Widget Start */}
                                        <div className="widget">
                                            <div className="widget--title">
                                                <h2 className="h4">Stay Connected</h2>
                                                <i className="icon fa fa-share-alt"></i>
                                            </div>

                                            {/* Social Widget Start */}
                                            <div className="social--widget style--6">
                                                <ul className="nav row gutter--20">
                                                    <li className="col-xs-6 col-xxs-12 facebook">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-facebook"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-facebook"></i>
                                                                <span>Facebook</span>
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="col-xs-6 col-xxs-12 twitter">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-twitter"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-twitter"></i>
                                                                <span>Twitter</span>
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="col-xs-6 col-xxs-12 google-plus">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-google-plus"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-google-plus"></i>
                                                                <span>Google Plus</span>
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="col-xs-6 col-xxs-12 pinterest">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-pinterest-p"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-pinterest-p"></i>
                                                                <span>Pinterest</span>
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="col-xs-6 col-xxs-12 dribbble">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-dribbble"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-dribbble"></i>
                                                                <span>Dribbble</span>
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="col-xs-6 col-xxs-12 linkedin">
                                                        <a href="#">
                                                            <span className="icon">
                                                                <i className="fa fa-linkedin"></i>
                                                            </span>
                                                            <span className="text">
                                                                <i className="fa fa-linkedin"></i>
                                                                <span>LinkedIn</span>
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            {/* Social Widget End */}
                                        </div>
                                        {/* Widget End */}

                                        {/* Widget Start */}
                                        <div className="widget">
                                            <div className="widget--title">
                                                <h2 className="h4">Get Newsletter</h2>
                                                <i className="icon fa fa-envelope-open-o"></i>
                                            </div>

                                            {/* Subscribe Widget Start */}
                                            <div className="subscribe--widget">
                                                <div className="content">
                                                    <p>Subscribe to our newsletter to get latest news, popular news and exclusive updates.</p>
                                                </div>

                                                <form action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d" method="post" name="mc-embedded-subscribe-form" target="_blank" data-form="mailchimpAjax">
                                                    <div className="input-group">
                                                        <input type="email" name="EMAIL" placeholder="E-mail address" className="form-control" autoComplete="off" required />

                                                        <div className="input-group-btn">
                                                            <button type="submit" className="btn btn-lg btn-default active"><i className="fa fa-paper-plane-o"></i></button>
                                                        </div>
                                                    </div>

                                                    <div className="status"></div>
                                                </form>
                                            </div>
                                            {/* Subscribe Widget End */}
                                        </div>
                                        {/* Widget End */}

                                        {/* Widget Start */}
                                        <div className="widget">
                                            <div className="widget--title">
                                                <h2 className="h4">Featured News</h2>
                                                <i className="icon fa fa-newspaper-o"></i>
                                            </div>

                                            {/* List Widgets Start */}
                                            <div className="list--widget list--widget-1">
                                                

                                                {/* Post Items Start */}
                                                <div className="post--items post--items-3" data-ajax-content="outer">
                                                    <ul className="nav" data-ajax-content="inner">
                                                        <li>
                                                            {/* Post Item Start */}
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-01.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Ninurta</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Post Item End */}
                                                        </li>
                                                        <li>
                                                            {/* Post Item Start */}
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-02.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Orcus</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Post Item End */}
                                                        </li>
                                                        <li>
                                                            {/* Post Item Start */}
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-03.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Rahab</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Post Item End */}
                                                        </li>
                                                        <li>
                                                            {/* Post Item Start */}
                                                            <div className="post--item post--layout-3">
                                                                <div className="post--img">
                                                                    <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-04.jpg" alt="" /></a>

                                                                    <div className="post--info">
                                                                        <ul className="nav meta">
                                                                            <li><a href="#">Tannin</a></li>
                                                                            <li><a href="#">16 April 2017</a></li>
                                                                        </ul>

                                                                        <div className="title">
                                                                            <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Post Item End */}
                                                        </li>
                                                    </ul>

                                                    {/* Preloader Start */}
                                                    <div className="preloader bg--color-0--b" data-preloader="1">
                                                        <div className="preloader--inner"></div>
                                                    </div>
                                                    {/* Preloader End */}
                                                </div>
                                                {/* Post Items End */}
                                            </div>
                                            {/* List Widgets End */}
                                        </div>
                                        {/* Widget End */}

                                        {/* Widget Start */}
                                        <div className="widget">
                                            <div className="widget--title">
                                                <h2 className="h4">Advertisement</h2>
                                                <i className="icon fa fa-bullhorn"></i>
                                            </div>

                                            {/* Ad Widget Start */}
                                            <div className="ad--widget">
                                                <a href="#">
                                                    <img src="img/ads-img/ad-300x250-2.jpg" alt="" />
                                                </a>
                                            </div>
                                            {/* Ad Widget End */}
                                        </div>
                                        {/* Widget End */}
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        
                        
                    </div>
                    
                </div>

                <div id="backToTop">
                    <a href="#"><i className="fa fa-angle-double-up"></i></a>
                </div>
            </div>
        </div>
    );
};

export default App;